export default "__VITE_ASSET__bpVWdSEknexLGdRA4MyGkg__";